import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
    actionsColumn,
    cityColumn,
    stateColumn,
    nameColumn,
    registeredDateColumn,
    userStatusColumn,
    warehouseColumn
} from "../../../shared/model/customers-table-column.model";
import { ManagementDataContainer, ManagementPageType } from "../../management-data-container";
import allUsersService from "../../../../services/all-users.service";
import { WarehouseModel } from "../../../../pages/shared/models/order/warehouse.model";
import { ManagementTab } from "./customer-view";
import {
    getCities,
    getCountries,
    getOrderStates,
    getProvinces,
    getRecipientDocumentTypes,
    getRegions
} from "../../../../redux/slices/static-data.slice";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import warehousesService from "../../../../services/warehouses.service";
import { WarehouseInfo } from "./warehouse-blocks/warehouse-info";
import { TabType } from "../../../shared/enums";
import { SettingsContainer, SettingsTabContainer, UserTabs } from "../../../../pages/user/settings/styled";
import { Tab } from "@mui/material";
import { Message, MessageSections } from "../../../../pages/components/message/message";
import { CountryInfo } from "./warehouse-blocks/country-info";
import { ManagementActionBar } from "../management-action-bar";

export const WarehouseView = () => {
    const { warehouseId } = useParams()

    const [isReady, setIsReady] = useState(false);
    const [warehouse, setWarehouse] = useState<WarehouseModel>();

    const [tabs, setTabs] = useState([] as ManagementTab[])
    const [tab, setTab] = useState<ManagementTab | undefined>(undefined);

    const { countries } = useAppSelector(state => state.staticDataReducer);

    const dispatch = useAppDispatch();

    const columns = [
        nameColumn,
        cityColumn,
        stateColumn,
        warehouseColumn,
        registeredDateColumn,
        userStatusColumn,
        actionsColumn
    ];

    useEffect(() => {
        if (warehouse && warehouseId && countries) {
            const warehouseCountry = countries.find(country => country.warehouse.some(item => item.warehouseId === warehouse.warehouseId));

            const warehouseTabs = [
                {
                    type: TabType.WORKERS,
                    messageKey: 'workers',
                    uniqueKey: 'workers.0',
                    component: <ManagementDataContainer columns={columns}
                        defaultFilter={{ userGroup: [4, 2], warehouse: +warehouseId }}
                        type={ManagementPageType.WAREHOUSE_WORKERS}
                        searchFunction={allUsersService.getAllUsers} />,
                },
                {
                    type: TabType.INFO,
                    messageKey: 'info',
                    component: <WarehouseInfo warehouse={warehouse} />,
                },
                {
                    type: TabType.COUNTRY,
                    messageKey: 'country',
                    component: warehouseCountry ? <CountryInfo country={warehouseCountry} /> : <></>
                }
            ]
            setTabs(warehouseTabs);
            setTab(warehouseTabs[0]);

            setIsReady(true);
        }
    }, [warehouse, countries])

    useEffect(() => {
        if (warehouseId && +warehouseId) {
            Promise.allSettled([
                warehousesService.getWarehouseById(+warehouseId),
                dispatch(getCountries()),
                dispatch(getProvinces()),
                dispatch(getCities()),
                dispatch(getOrderStates()),
                dispatch(getRegions()),
                dispatch(getRecipientDocumentTypes()),
            ]).then(([warehouseResponse]) => {
                if (warehouseResponse.status === 'fulfilled') {
                    const warehouse = warehouseResponse.value?.data;
                    setWarehouse(warehouse);
                }
            })
        }
    }, [])

    const handleChange = (selectedType: { type: TabType; messageKey: string; component: JSX.Element }) => {
        setTab(selectedType);
    };

    function handleActionDialogClosed() {
        // used to re-render warehouse workers component
        if (tab?.type === TabType.WORKERS && tab.uniqueKey) {
            const currentKey = + tab.uniqueKey.split('.')[1];

            setTab({ ...tab, uniqueKey: 'workers.' + (currentKey + 1) });
        }
    }

    if (warehouseId && isReady) {
        return (
            <SettingsContainer>
                <ManagementActionBar actionbarMessageKey={'warehouse'} type={ManagementPageType.WAREHOUSE_WORKERS} onActionDialogClosed={handleActionDialogClosed} withBackButton />

                <UserTabs value={tab ? tab.type : 0}
                    variant={"scrollable"}
                    scrollButtons={true}>
                    {
                        tabs.map(tabInfo => {
                            return (
                                <Tab value={tabInfo.type}
                                    key={tabInfo.messageKey}
                                    label={<Message messageKey={tabInfo.messageKey} sectionId={MessageSections.MAIN} />}
                                    onClick={() => handleChange(tabInfo)}
                                />
                            )
                        })
                    }
                </UserTabs>

                <SettingsTabContainer key={tab?.uniqueKey || ''}>
                    {tab ? tab.component : ''}
                </SettingsTabContainer>
            </SettingsContainer>
        )
    } else {
        return <></>
    }
}
